import { HalObjectLinks } from './hal-object-links.model';
export class HalObject {
  _links!: HalObjectLinks;
}
